import('reset-css');
import 'core-js/stable';
// import Vue from 'vue';
import { createApp, defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import '@/utils/async-pkg-fallback';
import '@/public-path';
import installZoomUI from '@/plugins/zoom-ui';
import '@/plugins/rewrireNumFix';
import ServiceComp from '@/plugins/service-comp';
import resolveI18n from '@/plugins/i18n';
import store from '@/store/index';
import routerCreator from '@/router/index';

import GlobalInstall from '@/global-install';
import { globalRebrandingMixin } from '@/global-install/global-mixin';
import GlobalListeners from '@/global-install/listeners';
import '@/utils/error-message-tracking.js';
import PortalVue from 'portal-vue';

// todo vue3 need to be optiomized
import '@/styles/index.scss';
import '@zoom/zoom-ui-vue3/css-variables.css';

import View from "@/views/index";
import persistShoppingBag from '@/views/config/shopping-cart/persist/persist-cart';

import { watchThemeChange } from '@/utils/modal-utils.js';
import { mountShoppingBag } from './shopping-bag';

import '@/utils/style-depollution.js';
import '@/utils/set-viewport.js';

watchThemeChange();

// debug dark mode in browser
// watchThemeChange(true);

// Vue.config.productionTip = true;
// Vue.config.devtools = true;


resolveI18n().then(i18n => {
    let options = defineComponent({
      extends: View,
      beforeCreate() {
        persistShoppingBag.initShoppingBagAction();
      },
      created(){
        (GlobalListeners.install.bind(this))();
      },
      beforeUnmount(){
        (GlobalListeners.uninstall.bind(this))();
      }
    });
    const App = createApp(options);


    App.config.devtools = true;
    App.use(store);
    App.mixin({
      computed: mapGetters([
        'is_desktop_reactive',
        'is_mobile_reactive',
        'is_tablet_reactive',
        'windowWidth',
      ]),
    });
    App.use(GlobalInstall);
    const router = routerCreator(i18n)
    App.use(router);
    App.use(i18n);
    App.mixin(globalRebrandingMixin);
    App.use(ServiceComp);
    App.use(PortalVue);

    installZoomUI(App);
    App.mount('#app');
    App.$router = router;
    App.mixin({
      mounted() {
          this.$el.__vue__ = this;
      }
    });
    App.$store = store;
    window.__rootApp__ = App;
    // Mount shopping bag component to header container
    mountShoppingBag({ store, i18n });
});
